<template>
  <div>
    <div class="container mt-3">
      <div class="row">
        <div class="col-12">
          <h1 class="text-primary">Leaderboard</h1>
          <p>Leaderboard for {{ gameSlug | cap }}. Updated every 5 minutes.</p>
        </div>
        <template v-for="(details, type) in gameTypes">
          <div class="col-md-6 col-lg-3 mt-4" v-bind:key="type">
            <h2><span :class="types[type].icon" :style="`--fa-primary-color: ${types[type].colorPrimary}; --fa-secondary-color: ${types[type].colorSecondary};`"></span>  {{ type | cap }}</h2>
            <h6>{{ types[type].desc }}</h6>
            <ul class="list-group list-group-flush" v-if="leaderboard && leaderboard[type]">
              <li class="list-group-item" v-for="l in leaderboard[type]" v-bind:key="l.u">
                <Username :username="l.p" :uid="l.u"></Username>&nbsp;<span class="badge">{{ l.r | floor }}</span>
              </li>
            </ul>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Username from '@/components/Username.vue';

import config from '@/config';

export default {
  name: 'leaderboard',
  props: ['gameSlug'],
  components: {
    Username,
  },
  computed: {
    gameTypes() {
      return _.omit(this.types, '_');
    },
  },
  created() {
    this.getLeaders();
  },
  methods: {
    getLeaders() {
      const db = window.firebase.database();
      db.ref('leaderboard').once('value').then((doc) => {
        const docVal = doc.val();
        this.leaderboard = docVal[this.gameSlug];
      });
    },
  },
  data() {
    return {
      types: config.types,
      leaderboard: {},
    };
  },
};
</script>
